// extracted by mini-css-extract-plugin
var _1 = "pUxp7Xnlil7ZlEWaZl71";
var _2 = "pUxp7Xnlil7ZlEWaZl71";
export { _1 as "right-align", _2 as "rightAlign" }
